import React from 'react';
var ContextNested = React.createContext({
  isNestedInParent: null,
  isNestedInlink: null
});

var getValidNestedChild = function getValidNestedChild(contextParent, tag) {
  switch (contextParent) {
    case 'table':
      return 'div';

    case 'p':
    case 'span':
      return 'span';

    default:
      return tag;
  }
};

export { ContextNested, getValidNestedChild };